import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blue-add",
  "use": "blue-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"blue-add\"><path d=\"M957.44 579.072H578.56V957.44c0 36.864-29.696 66.56-66.56 66.56s-66.56-29.696-66.56-66.56V579.072H66.56c-36.864 0-66.56-29.696-66.56-66.56s29.696-66.56 66.56-66.56h378.88V67.072c0-36.864 29.696-66.56 66.56-66.56s66.56 29.696 66.56 66.56V445.44h378.88c36.864 0 66.56 29.696 66.56 66.56 0 37.376-29.696 67.072-66.56 67.072z\" fill=\"#00a4f2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol